import React from "react";

import MainLogo from "../../assets/images/logo.jpg";
import "./Authpage.css";
import SmallLoader from "../../components/SmallLoader/SmallLoader";
import { Loader } from "react-feather";
import { useAuthPage } from "../../customHooks/AuthPage/useAuthPage";
import { RegistrationForm } from "../RegistrationForm/RegistrationForm";
import NotFound from "../NotFound/NotFound";
import UserNotFound from "../../components/UserNotFound/UserNotFound";
import { Toaster } from "react-hot-toast";

export default function AuthPage() {
  const hookProps = useAuthPage() || {};
  const {
    username = "",
    password = "",
    setUsername,
    setPassword,
    handleSubmit,
    errors,
    loading,
    showRegistration,
    apiKey,
    loader,
    apiKeyValid,
  } = hookProps;

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      {!loader ? (
        <>
          {" "}
          {!apiKey ? (
            <div className="LoginPageWrapper">
              <div className="Row">
                <div className="Colmd8">
                  <div className="maineformbox">
                    <div className="newloginBox">
                      <div className="maineweblogo">
                        <img src={MainLogo} alt="Logo" />
                      </div>
                      <h3 className="LoginHeading">Welcome!</h3>
                      <small>Continue to Login with Email and Password!</small>
                      <div className="Mt4 frontlogin">
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit(e);
                          }}
                        >
                          <div className="FormLabel">
                            <label>Email Address</label>
                            <input
                              type="text"
                              value={username}
                              className="FormControl"
                              onChange={(e) => setUsername(e.target.value)}
                              placeholder="Enter your email"
                            />
                            {errors.username && (
                              <small className="error-message">
                                {errors.username}
                              </small>
                            )}
                          </div>

                          <div className="FormLabel">
                            <label>Password</label>
                            <input
                              className="FormControl"
                              type="password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              placeholder="Enter your password"
                            />
                            {errors.password && (
                              <small className="error-message">
                                {errors.password}
                              </small>
                            )}
                          </div>

                          <div>
                            <button
                              className="SignInButton"
                              type="submit"
                              disabled={loading}
                            >
                              {/* {loading ? (
                                <Loader className="loader-icon" />
                              ) : ( */}
                                Sign In
                              {/* )} */}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {!apiKeyValid ? (
                <RegistrationForm apiKey={apiKey} />
              ) : (
                <UserNotFound />
              )}
            </>
          )}
        </>
      ) : (
        <>...Loading</>
      )}
    </>
  );
}
